import createModalModel, { prop } from './lib/create_modal_model';

export default createModalModel({
  modelName: 'UnlinkProfile',
  properties: {
    customerId: prop(String),
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/modal/unlink_profile.js